/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * MovingWorlds API
 * OpenAPI spec version: 0.1.0
 */
import { useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  CohortBaseDetail,
  GetCurrentUserCurrentCohort200,
  GetSimpleCohortsResponse,
  HTTPValidationError,
} from './platformapi.schemas';

import getCohortMutator from '../custom-axios-instance';
import getCohortsMutator from '../custom-axios-instance';
import getCurrentUserCurrentCohortMutator from '../custom-axios-instance';

/**
 * Retrieves a cohort by its ID
 * @summary Get Cohort
 */
export const getCohort = (cohortId: number, signal?: AbortSignal) => {
  return getCohortMutator<CohortBaseDetail>({
    url: `${import.meta.env['VITE_API_HOST']}/cohorts/cohort/${cohortId}`,
    method: 'GET',
    signal,
  });
};

export const getGetCohortQueryKey = (cohortId?: number) => {
  return [`${import.meta.env['VITE_API_HOST']}/cohorts/cohort/${cohortId}`] as const;
};

export const getGetCohortQueryOptions = <
  TData = Awaited<ReturnType<typeof getCohort>>,
  TError = void | HTTPValidationError,
>(
  cohortId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCohort>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCohortQueryKey(cohortId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCohort>>> = ({ signal }) =>
    getCohort(cohortId, signal);

  return { queryKey, queryFn, enabled: !!cohortId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCohort>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetCohortQueryResult = NonNullable<Awaited<ReturnType<typeof getCohort>>>;
export type GetCohortQueryError = void | HTTPValidationError;

export function useGetCohort<
  TData = Awaited<ReturnType<typeof getCohort>>,
  TError = void | HTTPValidationError,
>(
  cohortId: number,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCohort>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCohort>>,
          TError,
          Awaited<ReturnType<typeof getCohort>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetCohort<
  TData = Awaited<ReturnType<typeof getCohort>>,
  TError = void | HTTPValidationError,
>(
  cohortId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCohort>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCohort>>,
          TError,
          Awaited<ReturnType<typeof getCohort>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetCohort<
  TData = Awaited<ReturnType<typeof getCohort>>,
  TError = void | HTTPValidationError,
>(
  cohortId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCohort>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Cohort
 */

export function useGetCohort<
  TData = Awaited<ReturnType<typeof getCohort>>,
  TError = void | HTTPValidationError,
>(
  cohortId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCohort>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetCohortQueryOptions(cohortId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Retrieves all cohorts - excludes legacy MWI cohorts or any not linked to corporate clients.
 * @summary Get Cohorts
 */
export const getCohorts = (signal?: AbortSignal) => {
  return getCohortsMutator<GetSimpleCohortsResponse>({
    url: `${import.meta.env['VITE_API_HOST']}/cohorts/cohorts`,
    method: 'GET',
    signal,
  });
};

export const getGetCohortsQueryKey = () => {
  return [`${import.meta.env['VITE_API_HOST']}/cohorts/cohorts`] as const;
};

export const getGetCohortsQueryOptions = <
  TData = Awaited<ReturnType<typeof getCohorts>>,
  TError = void,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCohorts>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCohortsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCohorts>>> = ({ signal }) =>
    getCohorts(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCohorts>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetCohortsQueryResult = NonNullable<Awaited<ReturnType<typeof getCohorts>>>;
export type GetCohortsQueryError = void;

export function useGetCohorts<TData = Awaited<ReturnType<typeof getCohorts>>, TError = void>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCohorts>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCohorts>>,
          TError,
          Awaited<ReturnType<typeof getCohorts>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetCohorts<TData = Awaited<ReturnType<typeof getCohorts>>, TError = void>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCohorts>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCohorts>>,
          TError,
          Awaited<ReturnType<typeof getCohorts>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetCohorts<TData = Awaited<ReturnType<typeof getCohorts>>, TError = void>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCohorts>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Cohorts
 */

export function useGetCohorts<TData = Awaited<ReturnType<typeof getCohorts>>, TError = void>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCohorts>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetCohortsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Retrieves the current cohort for a given user
 * @summary Get Current User Current Cohort
 */
export const getCurrentUserCurrentCohort = (signal?: AbortSignal) => {
  return getCurrentUserCurrentCohortMutator<GetCurrentUserCurrentCohort200>({
    url: `${import.meta.env['VITE_API_HOST']}/cohorts/current`,
    method: 'GET',
    signal,
  });
};

export const getGetCurrentUserCurrentCohortQueryKey = () => {
  return [`${import.meta.env['VITE_API_HOST']}/cohorts/current`] as const;
};

export const getGetCurrentUserCurrentCohortQueryOptions = <
  TData = Awaited<ReturnType<typeof getCurrentUserCurrentCohort>>,
  TError = void | HTTPValidationError,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getCurrentUserCurrentCohort>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCurrentUserCurrentCohortQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCurrentUserCurrentCohort>>> = ({
    signal,
  }) => getCurrentUserCurrentCohort(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCurrentUserCurrentCohort>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetCurrentUserCurrentCohortQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCurrentUserCurrentCohort>>
>;
export type GetCurrentUserCurrentCohortQueryError = void | HTTPValidationError;

export function useGetCurrentUserCurrentCohort<
  TData = Awaited<ReturnType<typeof getCurrentUserCurrentCohort>>,
  TError = void | HTTPValidationError,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCurrentUserCurrentCohort>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCurrentUserCurrentCohort>>,
          TError,
          Awaited<ReturnType<typeof getCurrentUserCurrentCohort>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetCurrentUserCurrentCohort<
  TData = Awaited<ReturnType<typeof getCurrentUserCurrentCohort>>,
  TError = void | HTTPValidationError,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCurrentUserCurrentCohort>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCurrentUserCurrentCohort>>,
          TError,
          Awaited<ReturnType<typeof getCurrentUserCurrentCohort>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetCurrentUserCurrentCohort<
  TData = Awaited<ReturnType<typeof getCurrentUserCurrentCohort>>,
  TError = void | HTTPValidationError,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCurrentUserCurrentCohort>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Current User Current Cohort
 */

export function useGetCurrentUserCurrentCohort<
  TData = Awaited<ReturnType<typeof getCurrentUserCurrentCohort>>,
  TError = void | HTTPValidationError,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCurrentUserCurrentCohort>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetCurrentUserCurrentCohortQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}
